import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { StoreMemberView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerMembers } from "@/lib/query/core/invalidation";

type UpdateStoreMemberRolesInput = {
  storeSlug: string;
  memberId: string;
  roleIds: string[];
};

export function useUpdateStoreMemberRolesMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ memberId, roleIds }: UpdateStoreMemberRolesInput) =>
      apiJsonClient<StoreMemberView>(endpoints.seller.memberById(memberId), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ roleIds }),
      }),
    onSuccess: async (_data, variables) => {
      await invalidateSellerMembers(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
